module.exports = __webpack_public_path__ + "img/bg.50cd3526.jpg";